import { Box, Text } from '@fairfashion/design-system'

import { IDeclaration } from '../../../../sdk/declaration/finished-item-profile.types'
import { DeclarationTable } from '../../../DeclarationTable/declaration-table.comp'

interface DeclarationDataProps {
  declaration?: IDeclaration
}

export const DeclarationData = ({ declaration }: DeclarationDataProps) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('pt-BR')
  }

  const formatPercentage = (percentage: number) => {
    return `${percentage.toFixed(2)}%`
  }

  if (!declaration) return null

  return (
    <Box width="100%" direction="column" gap={3}>
      <Box direction="column" gap={2} width="100%">
        <Box direction="row" gap={4} width="100%">
          <Box gap={1} direction="column">
            <Text fontWeight={400} color="grey_3">
              Período
            </Text>
            <Text color="grey_1">
              {formatDate(declaration.from)} - {formatDate(declaration.to)}
            </Text>
          </Box>

          <Box gap={1} direction="column">
            <Text fontWeight={400} color="grey_3">
              Rastreado
            </Text>
            <Box
              padding={1}
              borderRadius="6px"
              backgroundColor={
                declaration.percentageTracked >= 80
                  ? 'success'
                  : declaration.percentageTracked >= 50
                    ? 'warning'
                    : 'error'
              }
            >
              <Text fontWeight={500} color="white">
                {formatPercentage(declaration.percentageTracked)}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box height="1px" backgroundColor="grey_5" width="100%" />

      <Text fontWeight={500} color="grey_1">
        Fornecedores ({declaration.lines.length})
      </Text>

      <DeclarationTable declaration={declaration} />
    </Box>
  )
}
